export default "<mat-chip-list *ngIf=\"label!==undefined && label!==null && label!==''\">\n    <mat-chip>{{label}}</mat-chip>\n</mat-chip-list>"